import React, { lazy, Suspense } from "react";

// Lazy load the components
const PlayerRanking = lazy(
  () => import("../Components/Toolbox/ToolboxModal/PlayerRanking"),
);
const PlayerProfile = lazy(
  () => import("../Components/Toolbox/ToolboxModal/PlayerProfile"),
);
const AiChatbotSeachModal = lazy(
  () => import("../Components/Chatbot/AiChatbotSeachModal/AiChatbotSeachModal"),
);
const LeagueModal = lazy(
  () => import("../Components/LeagueSyncModal/LeagueModal"),
);
const NewsDetailsModal = lazy(
  () => import("../Components/News/NewsDetailsModal/NewsDetailsModal"),
);

const ChatBotHistoryModal = lazy(
  () => import("../Components/Chatbot/AiChatbotSeachModal/ChatBotHistoryModal"),
);

const AdvancedStatsModal = lazy(
  () => import("../Components/Chatbot/AdvancedStatsModal/AdvancedStatsModal"),
);

const AppUpdateModal = lazy(
  () => import("../Components/AppUpdateModal/AppUpdateModal"),
);

const SleeperModal = lazy(
  () => import("../Components/LeagueSyncModal/SleeperModal"),
);
const LeagueSelectionModal = lazy(
  () =>
    import(
      "../Components/LeagueSync/LeagueSelectionModal/LeagueSelectionModal"
    )
);
const TradeAnalyzerModal = lazy(
  () => import("../Components/TradeAnalyzers/TradeAnalyzerModal"),
);

const PlayerSearchModal = lazy(
  () => import("../Components/TradeAnalyzers/PlayerSearchModal"),
);

const LeagueSettingsModal = lazy(
  () => import("../Components/TradeAnalyzers/LeagueSettingsModal"),
);

const AddNewLeague = lazy(
  () => import("../Components/LeagueSync/AddNewLeague/AddNewLeague"),
);

const BookCallModal = lazy(
  () => import("../Components/BookCallModal/BookCallModal"),
);


const LeagueTypeModal = lazy(
  () => import("../Components/TradeAnalyzers/LeagueTypeModal"),
);

const ScoringFormatModal = lazy(
  () => import("../Components/TradeAnalyzers/ScoringFormatModal"),
);

const ModalComponents: React.FC = () => {
  return (
    <>
      <Suspense fallback={null}>
        <PlayerRanking />
        <PlayerProfile />
        <AiChatbotSeachModal />
        <LeagueModal />
        <NewsDetailsModal />
        <ChatBotHistoryModal />
        <AdvancedStatsModal />
        <AppUpdateModal />
        <SleeperModal />
        <NewsDetailsModal />
        <LeagueSelectionModal />
        <AddNewLeague />
        <BookCallModal />
        <TradeAnalyzerModal />
        <PlayerSearchModal />
        <LeagueSettingsModal />
        <LeagueTypeModal/>
        <ScoringFormatModal/>
      </Suspense>
    </>
  );
};

export default ModalComponents;
